//export const apiUrl = 'https://savemyanmar.duredemos.com/service/';
//export const baseUrl = 'https://savemyanmar.duredemos.com';

import { appApiUrl, appBaseUrl } from "../config/appConfig";

export const apiUrl = appApiUrl;
export const baseUrl = appBaseUrl;

export const getData = "api/34/dashboards/Aeo6r9jlo9R.json";
